"use client";

import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EstetikDolguTanitimi() {
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setOffsetY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="estetik-dolgu-tanıtımı" className="w-full min-h-screen flex flex-col lg:flex-row bg-background overflow-hidden relative">
      {}
      <div className="flex-1 flex flex-col justify-center px-8 py-20 lg:px-16 xl:px-24 z-10 bg-background lg:bg-transparent">
        <div ref={textRef} className={`max-w-xl transition-all duration-1000 ease-out transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Badge variant="outline" className="text-primary border-primary/40 rounded-[2px] mb-8 uppercase tracking-[0.2em] text-xs px-3 py-1.5 bg-transparent backdrop-blur-sm">
            Premium Dental Art
          </Badge>
          
          <h1 className="font-serif text-6xl lg:text-[84px] leading-[0.95] tracking-wide text-foreground mb-8">Estetik Dolgu (Bonding)</h1>
          
          <p className="font-sans text-base text-muted-foreground mb-12 leading-relaxed max-w-md">
            Sağlık ve sanatın kusursuz birleşimi. Doğal diş yapınızı korurken, 
            gülüşünüze estetik, zarif ve tamamen size özel bir dokunuş katıyoruz.
          </p>
          
          <Button asChild size="lg" className="rounded-[2px] bg-gradient-to-r from-primary to-accent-foreground text-primary-foreground border-0 hover:opacity-90 transition-opacity w-fit px-10 h-14 text-base font-medium shadow-lg shadow-primary/20">
            
          </Button>
        </div>
      </div>

      {}
      <div className="flex-1 relative min-h-[50vh] lg:min-h-screen overflow-hidden bg-secondary/20">
        {}
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-background to-transparent hidden lg:block z-10 pointer-events-none" />
        
        <div className="absolute inset-[-15%] w-[130%] h-[130%] will-change-transform" style={{
        transform: `translateY(${offsetY * 0.15}px)`
      }}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/radiant_smile_high_key.png" alt="Estetik gülüş tasarımı ve dolgu uygulaması" className="w-full h-full object-cover object-center opacity-95" />
        </div>
      </div>
    </section>;
}